var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isStickyDisplayed)?_c('AdvMobileStickyRsyaBody',{attrs:{"adv":_vm.adv,"isReload":_vm.isReload}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }